<template>
	<div class="common_layout">
		<TopHeader title="訂單詳情" :isfilter="'update'" :filterClick="updateOrderDetail" />

		<div class="order" style="position: relative">
			<div class="row">
				<div class="left" :style="{ width: detailData.value.orderType === 2 ? '84px' : '58px' }">
					訂單號
				</div>
				<div class="right">{{ detailData.value.id }}</div>
			</div>
			<div class="row">
				<div class="left" :style="{ width: detailData.value.orderType === 2 ? '84px' : '58px' }">
					子管理員
				</div>
				<div class="right">{{ detailData.value.username }}</div>
			</div>
			<div class="row">
				<div class="left" :style="{ width: detailData.value.orderType === 2 ? '84px' : '58px' }">
					創建時間
				</div>
				<div class="right">{{ detailData.value.createTime }}</div>
			</div>
			<div class="row">
				<div class="left" :style="{ width: detailData.value.orderType === 2 ? '84px' : '58px' }">
					付款方式
				</div>
				<div class="right">
					<div v-if="detailData.value.payMethod" class="righticon">
						{{
							detailData.value.payMethod === "weixin"
								? "微信支付"
								: detailData.value.payMethod === "alipay"
								? "支付寶"
								: "/"
						}}
					</div>
					<p v-else>/</p>
				</div>
			</div>
			<div class="row" v-if="detailData.value.orderType === 2">
				<div class="left" style="width: 84px">平台交易編號</div>
				<div class="right">
					{{ detailData.value.payNo ? detailData.value.payNo : "暫無平台交易編號" }}
				</div>
			</div>
			<div class="row" v-if="detailData.value.orderType === 2">
				<div class="left" style="width: 84px">商品名稱</div>
				<div class="right">JJ20線下周邊</div>
			</div>
			<div class="row" v-if="detailData.value.orderType === 2">
				<div class="left" style="width: 84px">訂單總計</div>
				<div class="right" style="color: #409eff; font-weight: bolder">
					{{ detailData.value.currency }}&nbsp;
					<span style="font-size: 18px">{{ detailData.value.totalMoney }}</span>
				</div>
			</div>
			<div v-if="detailData.value.orderStatus === 6" class="row">
				<div class="left">失敗原因</div>
				<div class="right">
					{{ detailData.value.remark }}
				</div>
			</div>

			<img
				v-if="detailData.value.orderStatus === 1"
				class="pay_success_img"
				src="../../assets/images/aliready_pay_img.png"
			/>

			<img
				v-if="detailData.value.orderStatus === 4"
				class="pay_success_img"
				style="width: 102px"
				src="../../assets/images/refund_cancel_img.png"
			/>

			<img
				v-if="detailData.value.orderStatus === 5"
				class="pay_success_img"
				src="../../assets/images/refunding_img.png"
			/>

			<img
				v-if="detailData.value.orderStatus === 6"
				class="pay_success_img"
				src="../../assets/images/refund_fail_img.png"
			/>
		</div>

		<!--子账号地址模块-->
		<div v-if="roleType === 'SUBACCOUNT' && detailData.value.orderType === 1">
			<div class="center_flex_layout" style="justify-content: space-between; margin-top: 10px">
				<p class="common_font">收貨明細</p>

				<el-button
					v-if="detailData.value.receiver && detailData.value.orderStatus === 1"
					@click="editAddress"
					style="border-radius: 0"
					type="primary"
					plain
					>修改</el-button
				>
			</div>

			<div v-if="detailData.value.receiver" class="order">
				<div v-if="detailData.value.receiver" class="row">
					<div class="left">收件人</div>
					<div class="right">{{ detailData.value.receiver }}</div>
				</div>
				<div v-if="detailData.value.receivePhone" class="row">
					<div class="left">電話</div>
					<div class="right">
						+{{ detailData.value.receiveCode }}&nbsp;{{ detailData.value.receivePhone }}
					</div>
				</div>
				<div v-if="detailData.value.receiveAddr" class="row">
					<div class="left">收貨地址</div>
					<div class="right">
						{{ detailData.value.receiveAddr }}
					</div>
				</div>
			</div>

			<el-button
				v-else-if="!detailData.value.receiver && detailData.value.orderStatus === 1"
				@click="changeAddress"
				style="border-radius: 0"
				type="primary"
				plain
				>添加</el-button
			>

			<p v-else>/</p>
		</div>

		<!--主管理员地址模块-->
		<div
			v-if="
				roleType === 'MANAGEMENT' && detailData.value.receiver && detailData.value.orderType === 1
			"
		>
			<p class="common_font" style="margin-top: 10px">收貨明細</p>

			<div class="order">
				<div v-if="detailData.value.receiver" class="row">
					<div class="left">收件人</div>
					<div class="right">{{ detailData.value.receiver }}</div>
				</div>
				<div v-if="detailData.value.receivePhone" class="row">
					<div class="left">電話</div>
					<div class="right">
						+{{ detailData.value.receiveCode }}&nbsp;{{ detailData.value.receivePhone }}
					</div>
				</div>
				<div v-if="detailData.value.receiveAddr" class="row">
					<div class="left">收貨地址</div>
					<div class="right">
						{{ detailData.value.receiveAddr }}
					</div>
				</div>
			</div>
		</div>

		<p v-if="detailData.value.orderType === 1" class="common_font" style="margin-top: 10px">
			商品明細
		</p>

		<div
			v-if="detailData.value.orderType === 1"
			class="order"
			style="border-bottom: 1px solid rgba(235, 238, 245, 1); padding: 12px"
		>
			<div
				v-for="(goods, index) in goodsDetailList"
				:key="goods.id"
				class="center_flex_layout"
				:style="{
					marginTop: index === 0 ? 0 : '20px',
					paddingTop: goods.goodsType === 2 ? '20px' : 0,
					borderTopWidth: goods.goodsType === 2 ? '1px' : 0,
					borderTopColor: '#EBEEF5',
					borderTopStyle: 'solid',
				}"
			>
				<el-image style="width: 85px; height: 85px" :src="goods.goodsImg" lazy />

				<div style="flex: 1; margin-left: 5px">
					<div
						class="center_flex_layout"
						style="justify-content: space-between; align-items: flex-start"
					>
						<p class="common_font goods_name_hidden">{{ goods.goodsName }}</p>

						<p class="common_font" style="margin-left: 5px">
							<span style="font-size: 10px">{{ goods.currency }}</span
							>{{ goods.goodsPrice }}
						</p>
					</div>

					<div class="center_flex_layout" style="justify-content: space-between; margin-top: 5px">
						<p class="common_font" style="color: rgba(96, 98, 102, 0.5)">
							{{ goods.goodsSpecial }}
						</p>

						<p class="common_font" style="color: rgba(96, 98, 102, 0.5)">x{{ goods.goodsNum }}</p>
					</div>
				</div>
			</div>
		</div>

		<div v-if="detailData.value.orderType === 1" class="order">
			<div class="row">
				<div class="left" style="width: 84px">商品總金額</div>
				<div class="right">
					{{ detailData.value.currency }}&nbsp;{{ detailData.value.goodMoney }}
				</div>
			</div>
			<!--<div class="row">-->
			<!--<div class="left" style="width: 84px;">包裝袋總金額</div>-->
			<!--<div class="right">{{detailData.value.currency}}&nbsp;{{detailData.value.packageMoney}}</div>-->
			<!--</div>-->
			<div class="row">
				<div class="left" style="width: 84px">訂單總計</div>
				<div class="right" style="color: #409eff; font-weight: bolder">
					{{ detailData.value.currency }}&nbsp;
					<span style="font-size: 18px">{{ detailData.value.totalMoney }}</span>
				</div>
			</div>
		</div>

		<div v-if="detailData.value.orderType === 1" style="height: 90px"></div>

		<div
			v-if="detailData.value.orderStatus === 1 || detailData.value.orderStatus === 6"
			class="order_bottom_button center_flex_layout"
			:style="{
				boxShadow: detailData.value.orderType === 2 ? 'none' : '0px -2px 5px rgba(0, 0, 0, 0.05)',
			}"
		>
			<el-button
				type="primary"
				style="width: 114px; border-radius: 2px"
				size="large"
				@click="refundCancel"
				>退款並取消訂單</el-button
			>
		</div>

		<!--退款提示-->
		<van-popup
			v-model:show="showPop"
			style="border-radius: 4px; width: 90%; padding: 16px"
			closeable
			:close-on-click-overlay="false"
			@close="closeIconAction"
		>
			<div v-if="refundStep === 1">
				<p class="common_font" style="font-size: 18px; font-weight: bolder">提示</p>

				<p class="common_font" style="color: #606266; margin-top: 16px">是否退款並取消該訂單？</p>

				<p class="common_font" style="color: #606266">點擊退款後款項將直接原路退回到付款賬戶</p>

				<p style="font-size: 16px; font-weight: bolder; color: #409eff">
					退款金額：{{ detailData.value.currency }}&nbsp;{{ detailData.value.totalMoney }}
				</p>

				<div class="center_flex_layout" style="justify-content: flex-end; margin-top: 38px">
					<el-row>
						<el-button size="large" @click="onClickOverlay">取消</el-button>
						<el-button type="primary" size="large" @click="confirmNext">下一步</el-button>
					</el-row>
				</div>
			</div>

			<div v-else-if="refundStep === 2">
				<p class="common_font" style="font-size: 18px; font-weight: bolder">請輸入登入密碼</p>

				<el-input
					prefix-icon="Lock"
					size="large"
					class="common_font"
					style="margin-top: 20px"
					v-model="password"
					placeholder="請輸入登入密碼"
					type="password"
					show-password
				/>

				<div class="center_flex_layout" style="justify-content: flex-end; margin-top: 38px">
					<el-button type="primary" size="large" @click="confirmRefund">退款並取消訂單</el-button>
				</div>
			</div>

			<div style="margin: 30px 0" v-else-if="refundStep === 'address'">
				<div class="center_flex_layout">
					<div id="addressQrcode" ref="qrcode"></div>
				</div>

				<p class="common_font" style="color: #606266; margin-top: 16px; text-align: center">
					請向用戶出示二維碼以填寫/修改收貨地址
				</p>
			</div>
		</van-popup>
	</div>
</template>

<script setup>
import { reactive, ref, onMounted, getCurrentInstance } from "vue";
import QRCode from "qrcodejs2";
import { useRouter } from "vue-router";
import { addressDataFn } from "../../utils/secret";
import { get, post } from "../../utils/request";
import { Decrypt } from "../../utils/secret";
const { proxy } = getCurrentInstance();
const router = useRouter();

const roleType = ref("");
const orderId = reactive({ value: "" });
const detailData = reactive({ value: "" });
const goodsDetailList = ref([]);
const showPop = ref(false);
const refundStep = ref(1);
const password = ref("");

onMounted(() => {
	roleType.value = localStorage.role;

	//先解码再解密
	if (router.currentRoute.value.query.orderNum) {
		const encodedData = JSON.parse(
			Decrypt(decodeURIComponent(router.currentRoute.value.query.orderNum))
		);
		orderId.value = encodedData;
		// orderId.value = '857970000500';
	}

	getDetailData("init");
});

const getDetailData = (type) => {
	get(`/manager/order/detail?id=${orderId.value}`, {}, type === "init" ? true : false)
		.then((res) => {
			console.log(JSON.stringify(res));
			if (res.code == 1) {
				detailData.value = res.result;
				detailData.value.createTime = proxy
					.$date(detailData.value.createTime)
					.format("YYYY-MM-DD HH:mm:ss");
				goodsDetailList.value = res.result.detailDtoList;
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

const refundCancel = () => {
	showPop.value = true;
	refundStep.value = 1;
	password.value = "";
};

const onClickOverlay = () => {
	showPop.value = false;
};

const confirmNext = () => {
	refundStep.value = 2;
};

const confirmRefund = () => {
	if (!password.value) {
		proxy.$toast("請輸入登入密碼");
		return;
	}

	let refundParams = {
		id: orderId.value,
		password: password.value,
	};

	post("/manager/order/refund", refundParams, null)
		.then((res) => {
			// console.log(JSON.stringify(res));
			if (res.code == 1) {
				// proxy.$toast('退款成功');
				onClickOverlay();
				getDetailData("return");
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

const updateOrderDetail = () => {
	getDetailData("init");
};

const editAddress = () => {
	post("/manager/order/modify/address?id=" + orderId.value, {}, null)
		.then((res) => {
			// console.log(JSON.stringify(res));
			if (res.code == 1) {
				changeAddress();
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

const changeAddress = () => {
	showPop.value = true;
	refundStep.value = "address";

	setTimeout(() => {
		new QRCode("addressQrcode", {
			width: 200,
			height: 200,
			text: "https://api.sancttech.com:8079/?orderNum=" + orderId.value,
		});
	}, 50);
};

const closeIconAction = () => {
	if (refundStep.value === "address") {
		setTimeout(() => {
			let codePlate = document.getElementById("addressQrcode");
			codePlate.innerHTML = "";
		}, 300);
	}
};
</script>

<style lang="less" scoped>
.order {
	margin-top: 10px;
	box-sizing: border-box;
	border: 1px solid rgba(235, 238, 245, 1);
	border-bottom: 0px;
	.row {
		display: flex;
		align-items: center;
		background-color: #f5f7fa;
		position: relative;

		&:before {
			content: "";
			width: 100%;
			height: 1px;
			background: rgba(235, 238, 245, 1);
			position: absolute;
			left: 0;
			bottom: 0;
		}
	}
	.left {
		width: 58px;
		padding: 12px 16px;
		font-size: 14px;
		font-weight: 600;
		color: #606266;
	}
	.right {
		flex: 1;
		padding: 12px;
		padding-left: 16px;
		padding-right: 14px;
		border-left: 1px solid rgba(235, 238, 245, 1);
		background-color: #ffffff;
		font-size: 14px;
		font-weight: 400;
		color: #606266;
		display: flex;
		align-items: center;
		word-break: break-all;
		.money {
			font-size: 14px;
			font-weight: 600;
			color: #409eff;
		}
		.btn {
			width: 79px;
			height: 32px;
			background: #409eff;
			border-radius: 2px 2px 2px 2px;
			font-size: 14px;
			font-family: PingFang HK-Regular, PingFang HK;
			font-weight: 400;
			color: #ffffff;
			line-height: 32px;
			text-align: center;
		}
	}
	.righticon {
		padding: 0px 10px;
		width: max-content;
		background: #ecf5ff;
		border-radius: 4px 4px 4px 4px;
		opacity: 1;
		border: 1px solid #d9ecff;
		font-size: 12px;
		font-weight: 400;
		color: #409eff;
		height: 24px;
		line-height: 24px;
	}
}

.goods_name_hidden {
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
}

.pay_success_img {
	width: 81px;
	height: 61px;
	position: absolute;
	top: 14px;
	right: 0;
}

.order_bottom_button {
	width: 100%;
	padding: 25px 0;
	position: fixed;
	bottom: 0;
	left: 0;
	background: #ffffff;
	box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.05);
}
</style>
